module.exports = __webpack_public_path__ + "img/Integración-outer.5d3767dd.png";